import {
    Injectable
} from '@angular/core';
import {
    ProfileService
} from '../../firebase/profile.service';
import {
    Actions,
    createEffect,
    ofType
} from '@ngrx/effects';
import {
    Observable, Subscription
} from 'rxjs';
import * as ProfileAction from './profile.actions';
import {
    map,
    pluck,
    tap,
} from 'rxjs/operators';
import * as AuthActions from '../auth/auth.actions';
import {
    ProfileStateDispatcher
} from './profile.dispatcher';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';


@Injectable()
export class ProfileEffects {

    profileSub: Subscription;

    constructor(
        private profileService: ProfileService,
        private actions$: Actions,
        private sopoLoadingCtrl: SopoLoadingService,
        private store: Store<AppState>,
        private profileDispatcher: ProfileStateDispatcher,
    ) {}

    
    profileRequested$: Observable < void > = createEffect(() => this.actions$
        .pipe(
            ofType(ProfileAction.profileRequestedAction),
            map(payload => {
                if (this.profileSub && !this.profileSub.closed) return;
                this.sopoLoadingCtrl.present('profile');
                this.profileSub = this.profileService.getProfile(payload.profileId).subscribe(profile => {
                    this.store.dispatch(ProfileAction.profileFetchSucceededAction({profileData: profile}));
                })
            })
        ), {
        dispatch: false
    });

    
    profileFetched$ = createEffect(() => this.actions$
        .pipe(
            ofType(ProfileAction.profileFetchSucceededAction, ProfileAction.profileFetchFailedAction),
            tap(() => this.sopoLoadingCtrl.dismiss('profile'))
        ), {
        dispatch: false
    });

    
    logout$ = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.logoutAction),
            tap(() => {
                if (this.profileSub) this.profileSub.unsubscribe();
                this.sopoLoadingCtrl.dismiss('profile');
            }),
            map(() => ProfileAction.clearProfileAction())
        ));

    
    login$ = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.authenticatedAction),
            map((action) => {
                this.profileDispatcher.createSubscirptions(action.userData.uid);
                return ProfileAction.profileRequestedAction({profileId: action.userData.uid});
            })
        ));


    notAuthenticated$ = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.notAuthenticatedAction),
            map((action) => {
                this.sopoLoadingCtrl.dismiss('profile');
            })
        ), {
            dispatch: false,
        });
}
